// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"220":"appointment","409":"doctor","580":"schedule","931":"detail_doctor","982":"detail_specialist"}[chunkId] + "." + {"220":"150fd4bf","409":"167f3a6c","580":"5cd305b8","931":"150fd4bf","982":"150fd4bf"}[chunkId] + ".css";
};